import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/prop-types */
import { useEffect, useRef, useState } from "react";
import DraggableList from "react-draggable-list";
import { getAllGreeksDummy } from "src/apis/mock/data/all-greeks";
import styles from "./option-chain.module.scss";
import { getPreferences, setPreferences } from "src/utils/methods";
import { SESSION_KEYS, getDataFromSession, setDataInSession, } from "src/utils/session-storage";
const DraggableGreeksList = ({ onConfirm, isFullScreenView, position, isMultiple, }) => {
    const defaultGreeks = [
        { id: "DELTA" },
        { id: "THETA" },
        { id: "VEGA" },
        { id: "GAMMA" },
        { id: "IV" },
    ];
    const [list, setList] = useState([]);
    const containerRef = useRef();
    const [greeksOptions, setGreeksOptions] = useState(getAllGreeksDummy());
    const myPreferences = getPreferences();
    const [errorMsg, setErrorMsg] = useState("");
    const [placeholder, setPlaceHolder] = useState(5 - list.length);
    // const greeksSetting.expandedGreeks = "greeksSetting.expandedGreeks";
    // const greeksList ="greeksList";
    const _onListChange = (newList) => {
        setList(newList);
    };
    useEffect(() => {
        if (isFullScreenView) {
            const getSelectedGreek = position == 1 || !isMultiple
                ? myPreferences.optionChain.selected[0].greeksList
                : position == 2
                    ? myPreferences.optionChain.selected[1].greeksList
                    : defaultGreeks;
            const listLength = getSelectedGreek
                ? getSelectedGreek.length
                : defaultGreeks.length;
            setList(getSelectedGreek ? getSelectedGreek : defaultGreeks); //async
            setPlaceHolder(5 - listLength);
        }
        else {
            if (!getDataFromSession(SESSION_KEYS.GREEKSLIST))
                setDataInSession(SESSION_KEYS.GREEKSLIST, defaultGreeks, true);
            setList(getDataFromSession(SESSION_KEYS.GREEKSLIST) || "[]"); //async
            setPlaceHolder(5 - (getDataFromSession(SESSION_KEYS.GREEKSLIST) || "[]").length);
        }
        return () => {
            containerRef.current = undefined;
        };
    }, []);
    //function to filter greek options selected greeks must not appear in greeksOptions
    function filterDuplicateGreeksOptions() {
        let updatedGreeksOptions = greeksOptions;
        list.map((item) => {
            updatedGreeksOptions = updatedGreeksOptions.filter((updatedItem) => item.id !== updatedItem);
        });
        setGreeksOptions(updatedGreeksOptions);
    }
    useEffect(() => {
        filterDuplicateGreeksOptions();
    }, [list]);
    const Item = ({ item, dragHandleProps }) => {
        const { onMouseDown } = dragHandleProps;
        return (_jsx("div", Object.assign({ className: styles.deltaListItem }, { children: _jsxs("div", Object.assign({ className: "d-flex align-items-center justify-content-between w-100" }, { children: [_jsxs("div", Object.assign({ className: "d-flex align-items-center " }, { children: [_jsx("span", Object.assign({ className: `${styles.plusMinusBox} ${styles.minusBox} pointer`, onClick: () => removeGreek(item.id) }, { children: "\u2212" })), _jsx("span", Object.assign({ className: "medium ms-1 text-capitalize" }, { children: item.id }))] })), _jsx("span", { className: "optionIcon", onMouseDown: (e) => {
                            document.body.style.overflow = "hidden";
                            onMouseDown(e);
                        } })] })) })));
    };
    function createPlaceHolder() {
        const places = [];
        for (let i = 0; i < placeholder; i++)
            places.push(_jsx("div", Object.assign({ className: `${styles.addMoreGreeks} d-flex align-items-center justify-content-center` }, { children: _jsx("span", Object.assign({ className: "darkGreyText medium" }, { children: " + Add Greek" })) })));
        return places;
    }
    //function to remove greeks from selected greeks section
    function removeGreek(greekvalue) {
        if (list.length == 2)
            setErrorMsg("Minimum 2 greeks must be selected");
        else {
            setPlaceHolder((placeholder) => placeholder + 1);
            // const updatedList: any = list.filter((item: any): boolean => {
            //   return item.id !== id;
            // });
            const updatedList = list.filter(({ id }) => {
                return id !== greekvalue;
            });
            setList(updatedList);
            setErrorMsg("");
            const updatedGreeks = [greekvalue, ...greeksOptions];
            setGreeksOptions(updatedGreeks);
        }
    }
    //function to  greeks to selected greeks section
    function addGreek(id) {
        if (list.length == 5 && !isFullScreenView)
            setErrorMsg("Maximum 5 greeks can be shown in mini view");
        else {
            const newItem = greeksOptions[id];
            setPlaceHolder((placeholder) => placeholder - 1);
            if (list.length === 0)
                setList([{ id: newItem }]);
            else
                setList([...list, { id: newItem }]);
            const updatedGreeks = greeksOptions.filter((item, index) => id !== index);
            setGreeksOptions(updatedGreeks);
            setErrorMsg("");
        }
    }
    function setGreeksOnConfirm() {
        if (!isFullScreenView) {
            setDataInSession(SESSION_KEYS.GREEKSLIST, list, true);
        }
        else {
            if (position == 1 || !isMultiple) {
                myPreferences.optionChain.selected[0].greeksList = list;
                setPreferences(myPreferences);
            }
            if (position == 2) {
                myPreferences.optionChain.selected[1].greeksList = list;
                setPreferences(myPreferences);
            }
        }
    }
    // const getGreeksOption = async (): Promise<void> => {
    //   try {
    //     const response = await getOptionsGreeks();
    //     // setMarginPlus("N");
    //     console.log(response);
    //   } catch (error) {
    //     console.error("error ", error);
    //   }
    // };
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ ref: containerRef, className: `${styles.deltaList} ${styles.deltaSelected}` }, { children: _jsx(DraggableList, { itemKey: "id", template: Item, list: list, onMoveEnd: (newList) => _onListChange(newList), container: () => containerRef.current }) })), _jsx("div", Object.assign({ className: `${styles.addMoreGreeksWrapper}` }, { children: createPlaceHolder() })), _jsx("div", { className: `${styles.dividerBorder}` }), _jsx("div", Object.assign({ className: `${styles.deltaList} pt-2` }, { children: greeksOptions.map((item, i) => (_jsx("div", Object.assign({ className: styles.deltaListItem }, { children: _jsx("div", Object.assign({ className: "d-flex align-items-center justify-content-between w-100" }, { children: _jsxs("div", Object.assign({ className: "d-flex align-items-center " }, { children: [_jsx("span", Object.assign({ className: `${styles.plusMinusBox} ${styles.plusBox} pointer`, onClick: () => {
                                        addGreek(i);
                                    } }, { children: "+" })), _jsx("span", Object.assign({ className: "medium ms-1 darkGreyText" }, { children: item }))] })) })) }), i))) })), _jsx("p", Object.assign({ className: "error mx-2 medium" }, { children: errorMsg })), _jsx("div", Object.assign({ className: "mx-2 mb-3 mt-4" }, { children: _jsx("button", Object.assign({ className: "btnType1 w-100", onClick: () => {
                        setGreeksOnConfirm();
                        onConfirm();
                    } }, { children: "Confirm" })) }))] }));
};
export default DraggableGreeksList;
